<!--
 * @Description: 首页·mobile 第1个模块 （头图）
 * @Author: xiehuaqiang
 * @FilePath: /kada-official-web/public/mobile/src/views/home/QRAndBg.vue
 * @Date: 2020-12-18 10:00:18
-->
<template>
    <div class='module-cont module-app'>
        <header class="home-header">
            <img
                src="//cdn.hhdd.com/frontend/as/i/748413ef-3bfb-5b5b-b024-33997cd70378.png"
                alt="header_banner">
            <i class="btn" @click="downApp" />
        </header>
    </div>
</template>

<script>
    export default {
        components:{},
        data() {
            return {}
        },
        methods: {
            downApp() {
            if (device.ios || device.android) {
                // this.$uweb.trackEvent('events', "official-download", "mobile");
                setTimeout(()=> {
                    location.href = "http://www.hhdd.com/app";
                }, 100);
            }
        }
        },
    }
</script>

<style lang='stylus' scoped>
@import "../../style/vui/mixins"
.module-app
    .home-header
        position relative
        img
            // height px2rem2(474)
        .btn
            position absolute
            left px2rem2(20)
            bottom px2rem2(182)
            width px2rem2(150)
            background transparent
            border none
</style>



// WEBPACK FOOTER //
// src/views/home/QRAndBg.vue